import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

export const GAListener = () => {
  const location = useLocation();

  useEffect(() => {
    // Send a pageview event to Google Analytics every time the location changes
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; // This component doesn't render anything
};